import React from "react";
import { graphql, useStaticQuery } from "gatsby";
import Layout from "../components/layout";
// import ArticlesComponent from "../components/articles";
import "../assets/css/main.css";
import { Link } from "gatsby";
import YunJia from "../components/yunJia"
import LianXi from "../components/lianXi"

const IndexPage = () => {
  const data = useStaticQuery(query);
  const news = data.topTenNews.edges
  // console.log(news)
  return (
    <Layout seo={data.strapiHomepage.seo}>
    <table width="970" border="0" cellSpacing="0" cellPadding="0" align="center" bgcolor="#FFFFFF">
    <tbody><tr>
      <td width="265" valign="top">
      <table width="263" border="0" cellSpacing="0" cellPadding="0" align="center">
        <tbody><tr>
          <td>&nbsp;</td>
        </tr>
              <tr>
          <td width="263" height="38" background="/images/left_bj1.gif" style={{ paddingLeft: '25px' }}>&nbsp;<span className="STYLE3">航空货运行业新闻</span>&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;<a href="#">&gt;&gt;More</a></td>
    </tr>
        <tr>
          <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
            <tbody><tr>
              <td width="1" bgcolor="#e5e5e9"></td>
              <td width="261">
            <table width="95%" border="0" cellPadding="0" cellSpacing="0" align="center">
    
    <tbody>
    {news.map(post => {
      {/* console.log(post.node.strapiId) */}
          return (
    <tr key={post.node.strapiId}>
    <td height="25" align="left" width="78%"><img src="/images/jt.gif" width="3" height="5" />&nbsp;<Link to={`/article/${post.node.slug}`} className="uk-link-reset">{post.node.title}</Link></td>
    </tr>
          )
        })}
    {/* <tr>
    <td colSpan="2" height="1" width="579" background="/images/xx.jpg"></td>
    </tr> */}
    </tbody>
    </table>
    </td>
    <td width="1"></td>
    </tr>
    </tbody></table></td>
        </tr>
        <tr>
          <td width="263" height="1" bgcolor="#e5e5e9"></td>
        </tr>
              <tr>
          <td>&nbsp;</td>
        </tr>
      </tbody>
      </table>
      {/* 运价 */}
      <YunJia />
       {/* end运价 */}
      <table style={{marginTop: '10px'}} cellSpacing="0" cellPadding="0" width="214" border="0" align="center" background="/images/6.gif" height="200">
                <tbody>
                <tr>
                  <td height="20"></td>
                </tr>
                <tr>
                  <td>
                    <table cellSpacing="0" cellPadding="8" width="210" align="center" border="0">
                      <tbody>
                      <tr><td align="left"><LianXi /></td></tr> 
                      </tbody>
                          </table>
                          </td>
                          </tr>
                          </tbody>
                          </table>
    </td>
      {/* 右栏 */}
      <td valign="top">
      <table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
      <tbody><tr>
        <td>&nbsp;</td>
      </tr>
      <tr>
        <td width="669" height="37" background="/images/index_bj1.gif" style={{paddingLeft:'25px'}}>&nbsp;<span className="STYLE3">上海东大空运10月最新国内运价!</span></td>
      </tr>
      <tr>
        <td><table width="100%" border="0" cellSpacing="0" cellPadding="0">
  <tbody><tr>
            <td width="1" bgcolor="#e5e5e9"></td>
    <td width="667">
    <table width="90%" border="0" cellSpacing="0" cellPadding="0" align="center" className="TOP3">
                        <tbody><tr>
                          <td height="35" align="center">上海东大空运10月最新国内运价!</td>
                        </tr>
                        <tr>
                          <td height="1" colSpan="2" background="/images/naBialym.gif"><img height="1" src="/images/1x1_pix.gif" width="10" /></td>
                        </tr>
                        <tr>
                          <td colSpan="2"><table width="95%" border="0" cellSpacing="0" cellPadding="0" align="center">
  <tbody><tr>
    <td><div>
                            <p>国内空运5.5元特价：北京，深圳，大连，厦门，天津，重庆，石家庄，济南，沈阳，哈尔滨，长春，南京，杭州，西安，福州，广州，郑州，成都，长沙，武汉，合肥，南昌，海口，昆明，银川，呼和浩特，南宁。 <br />国内空运7.5元特价：太原，兰州，西宁。(专线3-5元每公斤48小时） <br />国内空运10元特价：澳门，香港，乌鲁木齐，拉萨，台湾15元 <br />二级城市6元特价：青岛，烟台，威海，临沂，济宁，延吉，邯郸，丹东，秦皇岛，大同，鸡西，唐山，齐齐哈尔，牡丹江，洛阳，乌海，宜宾，嘉峪关，北海，晋江，襄樊，恩施，赣州，九江，运城，阜阳，安庆，淮安，宜昌，井冈山，宁波，温州，舟山，黄山，黄岩，徐州，连云港，敦煌，榆林，汕头，桂林，柳州，三亚，珠海，武夷山，达县，泸州，南充，绵阳，张家界，万州，西双版纳，丽江，香格里拉 <br />二级城市7元特价：锦州，海拉尔，满洲里，长治， <br />二级城市18元特价：喀什，和田 <br />以上价格均为100KG以上门到门价格，最低100元一票，机场自提，各为9折价，上门提货70至100元一票。 <br />如有疑问请来电询价：021-64218058，13331816153 赵先生 应急电话：13901633174 吴先生</p>
                            </div></td>
  </tr>
</tbody></table>                          </td></tr>
                        <tr>
                          <td height="1" colSpan="2" background="/images/naBialym.gif"><img height="1" src="/images/1x1_pix.gif" width="10" /></td>
                        </tr>
                    </tbody></table>

</td>
            <td width="1" bgcolor="#e5e5e9"></td>
  </tr>
</tbody></table>
    <table width="100%" border="0" cellSpacing="0" cellPadding="0">
  <tbody><tr>
    <td height="35" align="center"><span className="STYLE5">咨询热线：021-62682618 021-51151242</span></td>
  </tr>
</tbody></table>
</td>
      </tr>
            <tr>
        <td width="669" height="1" bgcolor="#e5e5e9"></td>
      </tr>
    </tbody>
    </table>     
      </td>
      {/* end 右栏 */}
    </tr>
    </tbody></table>
    </Layout>
  );
};

const query = graphql`
  query {
    strapiHomepage {
      hero {
        title
      }
      seo {
        metaTitle
        metaDescription
        shareImage {
          publicURL
        }
      }
    }
    topTenNews: allStrapiArticle(limit: 10, filter: {category: {slug: {eq: "news"}}, status: {eq: "published"}}) {
      edges {
        node {
          title
          slug
          strapiId
          publishedAt
        }
      }
    }
    allStrapiArticle(filter: { status: { eq: "published" } }) {
      edges {
        node {
          strapiId
          slug
          title
          category {
            name
          }
          image {
            childImageSharp {
              fixed(width: 800, height: 500) {
                src
                ...GatsbyImageSharpFixed
              }
            }
          }
          author {
            name
            picture {
              childImageSharp {
                fixed(width: 30, height: 30) {
                  src
                  ...GatsbyImageSharpFixed
                }
              }
            }
          }
        }
      }
    }
  }
`;

export default IndexPage;
